(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var DOC = document;
  // mots trop courants pour porter du sens : ils seraient du bruit
  var STOP = ' LES DES UNE DANS POUR AVEC SUR PAR QUE QUI EST SONT PAS PLUS TOUT TOUS SES SON SANS MAIS OU DU DE LA LE ET EN AU AUX CE CES TON TES TA NE SE ';
  var NS = 'http://www.w3.org/2000/svg';
  var fil = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'));
  // Raccord au monogramme. La plume leve VITE : au-dela, un trait sombre et
  // deux fois plus epais que le fil arrive au premier titre et gene la lecture.
  var RACCORD = 64;
  // Distance à laquelle le fil s'interrompt de part et d'autre d'un objet.
  var GARDE = 22;
  // Les paliers d'assouplissement : sans eux, pas d'arrêt de la pointe.
  var PALIER = !!(window.CSS && CSS.supports && CSS.supports('animation-timing-function', 'linear(0, 1)'));

  // Les etiquettes gardent une VRAIE donnee — l'ordonnee du mot dans la page
  // — mais l'ecrivent comme une adresse.
  var TAG = ['0x', 'ptr', 'seq', 'crc', 'ref', 'off'];
  var HEX = '0123456789ABCDEF';

  // Vidage hexadecimal, suite DETERMINISTE : sinon le fond changerait a chaque
  // redimensionnement, et un fond qui scintille attire l'oeil.
  function vidage(graine, y) {
    var out = '', v = graine >>> 0, l, c;
    for (l = 0; l < 4; l++) {
      out += (l ? '\n' : '') + ((y + l * 16) & 0xffff).toString(16).toUpperCase().padStart(4, '0') + '  ';
      for (c = 0; c < 2; c++) {
        v = (v * 1103515245 + 12345) & 0x7fffffff;
        out += HEX[(v >>> 16) & 15] + HEX[(v >>> 20) & 15] + ' ';
      }
    }
    return out;
  }

  function words(sec) {
    var els = sec.querySelectorAll('h1, h2, h3, p, li');
    var seen = {}, out = [];
    for (var i = 0; i < els.length && out.length < 14; i++) {
      var parts = (els[i].textContent || '').toUpperCase().split(/[^A-ZÀ-Ü0-9]+/);
      for (var j = 0; j < parts.length; j++) {
        var w = parts[j];
        if (w.length < 5 || w.length > 13) continue;
        if (STOP.indexOf(' ' + w + ' ') > -1 || seen[w]) continue;
        seen[w] = 1;
        out.push(w);
      }
    }
    return out;
  }

  // On descend jusqu'au dernier enveloppeur qui peint vraiment un fond sur
  // toute la hauteur : sinon un bandeau à fond propre recouvrait la couche.
  function hostOf(sec) {
    var h = sec, kid = sec.firstElementChild, guard = 0;
    // La hauteur de la section ne change pas pendant qu'on descend dedans :
    // on la lit une fois, pas quatre.
    var hSec = sec.getBoundingClientRect().height * 0.8;
    while (kid && guard++ < 4) {
      var st = getComputedStyle(kid);
      var opaque = st.backgroundColor && st.backgroundColor !== 'rgba(0, 0, 0, 0)';
      if (!opaque || kid.getBoundingClientRect().height < hSec) break;
      h = kid;
      kid = kid.firstElementChild;
    }
    return h;
  }

  // Un contenu ÉPINGLÉ descend avec sa section : sa zone d'interdiction doit
  // couvrir sa course entière. La réponse ne dépend que de l'ancêtre, et
  // getComputedStyle par ancêtre est le poste le plus cher — on la retient.
  var passe = 0;
  function courseDe(el, host, hostH) {
    var vus = [], r = 0;
    for (var an = el; an && an !== host; an = an.parentElement) {
      if (an._vhPasse === passe) { r = an._vhCourse; break; }
      vus.push(an);
      if (getComputedStyle(an).position === 'sticky') {
        r = Math.max(0, hostH - an.getBoundingClientRect().height);
        break;
      }
    }
    for (var i = 0; i < vus.length; i++) { vus[i]._vhPasse = passe; vus[i]._vhCourse = r; }
    return r;
  }

  // Rectangles interdits : tout élément portant LUI-MÊME du texte, plus les
  // médias. Une liste de balises ne suffit pas : les libellés sont des <span>.
  function occupants(host, sx, sy) {
    var bad = [], all = host.querySelectorAll('*');
    var hostH = host.getBoundingClientRect().height;
    for (var i = 0; i < all.length; i++) {
      var el = all[i], porte = false, pave = false;
      for (var k = 0; k < el.childNodes.length; k++) {
        var nd = el.childNodes[k];
        if (nd.nodeType === 3 && nd.nodeValue.replace(/\s/g, '') !== '') { porte = true; break; }
      }
      if (!porte) {
        // Un SVG en ligne garde sa casse : tagName vaut « svg », jamais
        // « SVG » — le monogramme de signature n'était donc jamais évité.
        var tg = el.tagName.toUpperCase();
        porte = tg === 'IMG' || tg === 'SVG' || tg === 'VIDEO' || tg === 'PICTURE' || tg === 'INPUT';
        // Un titre dont le texte est decoupe en balises filles n'a aucun noeud
        // de texte direct : il passait au travers, et le fond ecrivait dans le
        // blanc entre deux de ses mots (mesure : « REPRESENTE TES ORIGINES »).
        if (!porte) {
          porte = tg === 'H1' || tg === 'H2' || tg === 'H3' || tg === 'H4' || tg === 'LI' || tg === 'BLOCKQUOTE';
          pave = porte;
        }
      }
      if (!porte) continue;
      var b = el.getBoundingClientRect();
      if (b.width < 4 || b.height < 4) continue;
      var course = courseDe(el, host, hostH);
      // l/r/t/b : boîte élargie, pour placer les mots. lx/rx/ty/by : boîte
      // réelle, pour couper le fil au plus juste. Le tout en repère hôte.
      // Un pave reserve DEJA son bloc : l'elargir comme un mot isole ne laissait
      // plus une seule case libre sur un ecran de 800 px.
      var eh = pave ? 7 : 22, ev = pave ? 5 : 14;
      bad.push({
        l: b.left - sx - eh, r: b.right - sx + eh, t: b.top - sy - ev, b: b.bottom - sy + course + ev,
        lx: b.left - sx, rx: b.right - sx, ty: b.top - sy, by: b.bottom - sy + course
      });
    }
    return bad;
  }

  // Être derrière ne suffit pas : les titres sont en fusion (ils inversent ce
  // qu'il y a dessous) et les packshots sont transparents. Là où un objet le
  // croise, le trait n'est simplement pas dessiné. Debout pour le fil, couché
  // pour les branches : le même algorithme, un seul exemplaire.
  function seg(vert, a, de, vers) {
    return vert ? 'M' + a + ' ' + Math.round(de) + ' V' + Math.round(vers)
                : 'M' + Math.round(de) + ' ' + a + ' H' + Math.round(vers);
  }
  function tronconne(vert, a, d0, d1, occ, garde) {
    if (garde === undefined) garde = GARDE;
    var coupes = [];
    for (var i = 0; i < occ.length; i++) {
      var o = occ[i];
      if ((vert ? o.lx : o.ty) > a || (vert ? o.rx : o.by) < a) continue;   // hors axe
      // Sept pixels, c'etait s'arreter AU RAS du texte : le fil mourait sur
      // l'accent du E de « PORTES » et se lisait comme un defaut de lettre.
      var u = (vert ? o.ty : o.lx) - garde;
      var v = (vert ? o.by : o.rx) + garde;
      // Un objet entièrement hors de la portion demandée doit être écarté AVANT
      // le rabotage : sinon son intervalle se retrouve inversé ([110, 64]), la
      // boucle le lit comme un début de coupe et fait dessiner jusque-là —
      // c'est-à-dire au-delà de d1. Invisible tant que d1 valait toute la
      // section ; le raccord, plus court, l'a fait sortir.
      if (v < d0 || u > d1) continue;
      coupes.push([Math.max(d0, u), Math.min(d1, v)]);
    }
    coupes.sort(function (p, q) { return p[0] - q[0]; });
    var d = '', c = d0;
    for (var k = 0; k < coupes.length; k++) {
      if (coupes[k][1] <= c) continue;
      if (coupes[k][0] - c > 10) d += seg(vert, a, c, coupes[k][0]);
      c = Math.max(c, coupes[k][1]);
    }
    if (d1 - c > 10) d += seg(vert, a, c, d1);
    return d;
  }

  var sceau = '';
  function build() {
    var main = DOC.getElementById('MainContent');
    if (!main) return;

    var vh = window.innerHeight;
    var docH = Math.max(DOC.documentElement.scrollHeight, DOC.body.scrollHeight);
    var course = docH - vh;
    var css = getComputedStyle(DOC.documentElement);

    // Le relevé se déclenche plusieurs fois par chargement. Si rien de ce
    // dont il dépend n'a bougé, le refaire coûterait une mesure de toute la
    // page pour rien. Les ancres du hero en font partie : elles sont
    // publiées après le premier relevé.
    // Le nombre d'éléments aussi : une app qui injecte son contenu APRÈS le
    // dernier relevé ne change pas forcément la hauteur du document, et le
    // fil ressortait alors à travers ce qu'elle venait de poser.
    // ON NE COMPTE PAS NOS PROPRES NŒUDS. Le sceau est censé rendre le second
    // relevé gratuit quand rien n'a bougé ; il ne l'était jamais, parce que la
    // passe précédente avait elle-même injecté ses calques dans #MainContent —
    // donc le compte différait forcément, donc on refaisait une mesure
    // complète de la page à chaque chargement, pour rien.
    var neuf = [docH, vh, DOC.documentElement.clientWidth,
                main.getElementsByTagName('*').length - DOC.querySelectorAll('.vhud, .vhud *').length,
                css.getPropertyValue('--vfil-top'), css.getPropertyValue('--vfil-x')].join('|');
    if (neuf === sceau) return;
    sceau = neuf;
    passe++;

    var vieux = DOC.querySelectorAll('.vhud');
    for (var v = 0; v < vieux.length; v++) vieux[v].remove();
    // L'hôte peut changer d'un relevé à l'autre : une classe oubliée laisse
    // un `isolation` parasite, donc un empilement qui piège la fusion.
    var hotes = DOC.querySelectorAll('.vhud-host');
    for (var w = 0; w < hotes.length; w++) hotes[w].classList.remove('vhud-host');

    if (course < 300) return;

    // Axe du fil : l'abscisse de la pointe de la dague, publiée par le hero.
    // Hors accueil, il n'y a pas de pointe : le fil garde l'axe médian.
    var filX = parseFloat(css.getPropertyValue('--vfil-x')) || DOC.documentElement.clientWidth / 2;
    var depart = parseFloat(css.getPropertyValue('--vfil-top'));
    if (!depart) depart = main.getBoundingClientRect().top + window.pageYOffset + 40;

    // La pointe précède le regard : elle vise le tiers haut de l'écran.
    var avance = vh * 0.42;
    function pct(y) {
      var p = (y - avance) / course * 100;
      return (p < 0 ? 0 : p > 99 ? 99 : p).toFixed(3) + '%';
    }

    // ON MESURE TOUT, PUIS ON POSE TOUT.
    // poser() finissait par un appendChild, et la section suivante commençait
    // par lire sa géométrie : chaque section payait donc un layout synchrone
    // provoqué par la mutation de la précédente — une dizaine par passe, sur
    // le fil principal, pendant l'affichage du premier écran. Les calques sont
    // maintenant assemblés puis posés d'un bloc, à la fin.
    var aPoser = [];
    var secs = main.children, idx = 0;
    for (var i = 0; i < secs.length; i++) {
      // On enjambe jusqu'à la prochaine section QUI EXISTE : une section vide
      // (0 px) faisait croire au pont qu'il était arrivé, et le fil restait
      // coupé sur 96 px avant le bandeau CTA.
      var apres = null;
      for (var s = i + 1; s < secs.length; s++) {
        if (secs[s].getBoundingClientRect().height >= 60) { apres = secs[s]; break; }
      }
      try { poser(secs[i], apres, idx++); } catch (e) { /* décoratif : on n'insiste pas */ }
    }
    for (var a = 0; a < aPoser.length; a += 2) aPoser[a].appendChild(aPoser[a + 1]);
    if (fil) DOC.documentElement.classList.add('vhud-fil');

    function poser(sec, suivante, idx) {
      var rs = sec.getBoundingClientRect();
      if (rs.height < 60) return;
      // Une section peut refuser le fil. La vitrine le fait : c'est une
      // sequence fermee, epinglee, ou un trait qui traverse le classement
      // n'aide personne a lire.
      if (sec.querySelector('[data-vhud-off]')) return;
      var host = hostOf(sec);
      var rh = host.getBoundingClientRect();
      var W = rh.width;
      var hostTop = rh.top + window.pageYOffset;
      // Les sections ne se touchent pas : entre deux fonds il reste un blanc
      // de 48 px, et le fil s'y interrompait huit fois sur la page d'accueil.
      // Chaque segment enjambe donc le vide qui le sépare du suivant.
      var H = rh.height;
      var pont = 0;
      if (suivante) {
        var g = (suivante.getBoundingClientRect().top + window.pageYOffset) - (hostTop + H);
        if (g > 0 && g < 260) pont = g;
      }
      var Hf = H + pont;

      var layer = DOC.createElement('div');
      layer.className = 'vhud';
      layer.setAttribute('data-vm', 'hud');
      layer.setAttribute('aria-hidden', 'true');
      if (pont) { layer.style.bottom = 'auto'; layer.style.height = Math.round(Hf) + 'px'; }

      // La couche de motifs passe la premiere : c'est le fond du fond. Elle
      // DERIVE au scroll ; le fil, lui, reste colle a ses branches.
      var motif = DOC.createElement('div');
      motif.className = 'vhud__motif';
      layer.appendChild(motif);

      var svg = DOC.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'vhud__svg');
      svg.setAttribute('viewBox', '0 0 ' + Math.round(W) + ' ' + Math.round(Hf));
      svg.setAttribute('preserveAspectRatio', 'none');
      layer.appendChild(svg);

      // --- le fil : segment droit, dans l'axe, sur toute la traversée -------
      var x = Math.round(filX - rh.left);
      var y0 = Math.max(0, depart - hostTop);
      var occ = occupants(host, rh.left, rh.top);
      var trace = false;
      if (x > 2 && x < W - 2 && Hf - y0 > 8) {
        var f = DOC.createElementNS(NS, 'path');
        f.setAttribute('class', 'vhud__fil');
        // Juste sous le monogramme, la garde est bien plus large. Le fil y
        // descend dans l'axe du grand titre — 637 px tombe en plein milieu de
        // « PORTÉS » — et s'arrêter au ras du mot le faisait pointer dedans.
        // Plus bas dans la page, la garde ordinaire suffit.
        var premier = hostTop + y0 < depart + 60;
        f.setAttribute('d', tronconne(true, x, y0, Hf, occ, premier ? 74 : GARDE));
        svg.appendChild(f);
        trace = !!f.getAttribute('d');

        // Le raccord au monogramme. Le fil lui-même est gris partout — c'est
        // un DOUBLON court, à la graisse et à l'encre du monogramme, posé
        // par-dessus et qui se dissout sur RACCORD px. Le fil gris est déjà
        // dessous : quand le doublon a disparu, il ne reste que lui. Ni marche
        // d'encre, ni marche de graisse, et surtout pas 900 px de noir.
        var gw = parseFloat(css.getPropertyValue('--vfil-w'));
        if (trace && hostTop + y0 < depart + 60 && gw > 0.4) {
          // Le raccord s'arrête au premier objet rencontré, même s'il n'a pas
          // fini sa dissolution. Il courait sur toute sa longueur et arrivait
          // encore sombre et épais en travers du titre de la vitrine : un
          // trait noir en pleine ligne de lecture. Sa place est entre le
          // monogramme et le premier texte, nulle part ailleurs.
          var stop = y0 + RACCORD;
          for (var q = 0; q < occ.length; q++) {
            var o = occ[q];
            if (o.lx > x || o.rx < x) continue;
            if (o.ty > y0 && o.ty - 7 < stop) stop = o.ty - 7;
          }
          var y1 = Math.min(Hf, stop);
          var dr = y1 - y0 > 16 ? tronconne(true, x, y0, y1, occ) : '';
          if (dr) {
            var gid = 'vhud-g' + idx;
            var lg = DOC.createElementNS(NS, 'linearGradient');
            lg.setAttribute('id', gid);
            lg.setAttribute('gradientUnits', 'userSpaceOnUse');
            lg.setAttribute('x1', 0); lg.setAttribute('y1', Math.round(y0));
            lg.setAttribute('x2', 0); lg.setAttribute('y2', Math.round(y1));
            [[0, 1], [0.28, 0.28], [1, 0]].forEach(function (s) {
              var st = DOC.createElementNS(NS, 'stop');
              st.setAttribute('offset', s[0]);
              st.setAttribute('stop-color', 'currentColor');
              st.setAttribute('stop-opacity', s[1]);
              lg.appendChild(st);
            });
            svg.appendChild(lg);
            var r = DOC.createElementNS(NS, 'path');
            r.setAttribute('class', 'vhud__fil');
            r.setAttribute('d', dr);
            r.setAttribute('stroke', 'url(#' + gid + ')');
            r.style.opacity = 1;
            r.style.strokeWidth = gw.toFixed(2);
            svg.appendChild(r);
          }
        }
      }

      // --- les mots, au bout de leur branche --------------------------------
      // On s'abstient là où une mécanique possède déjà l'espace, et là où le
      // contenu se déplie après la mesure.
      // Le seuil était à 260 px : les emplacements photo (240), la navigation
      // par pays (204) et d'autres bandes courtes n'avaient jamais de mots.
      // À 150 px une bande peut porter un mot et sa branche sans se serrer.
      var muette = sec.querySelector('[data-vorog-hero], [data-vorog-fs], [data-vorog-sig], [data-vtail]');
      // Les sections epinglees se taisent AUSSI pour les blocs : elles etalent
      // un titre sur toute la largeur et le deplacent pendant l'epinglage, donc
      // le releve fait a l'arret n'y vaut rien.
      if (!muette && H >= 150 && W >= 340) {
        blocs(occ, motif, W, H, Hf, y0, hostTop, idx);
        mots(occ, layer, motif, svg, x, y0, W, H, Hf, hostTop, idx, words(sec));
      }

      if (!trace && !layer.querySelector('.vhud__n') && !motif.firstChild) return;

      if (fil) {
        // Sur la COUCHE, pas sur le SVG : par heritage le SVG les recoit quand
        // meme, et la couche de motifs peut s'en servir pour sa derive.
        layer.style.setProperty('--a', pct(hostTop + y0));
        layer.style.setProperty('--b', pct(hostTop + Hf));

        // --- La pointe attend le titre ------------------------------------
        // Sous le monogramme, le fil s'arrête au-dessus du grand titre. Il
        // n'a aucune raison de repartir tant que ce titre est encore à
        // l'écran : la pointe MARQUE UN TEMPS, puis reprend sa descente une
        // fois le mot sorti par le haut.
        //
        // La descente est une seule animation liée au scroll ; on ne peut pas
        // y insérer une image-clé à un pourcentage calculé. Mais `linear()`
        // accepte des paliers : une valeur tenue entre deux positions de la
        // course. C'est exactement un arrêt.
        if (premier && PALIER) {
          var obs = null;
          for (var w2 = 0; w2 < occ.length; w2++) {
            var o2 = occ[w2];
            if (o2.lx > x || o2.rx < x) continue;
            if (o2.ty <= y0) continue;
            if (!obs || o2.ty < obs.ty) obs = o2;
          }
          if (obs) {
            var arret = obs.ty - 74;
            var sA = hostTop + y0 - avance;
            var sB = hostTop + Hf - avance;
            var s1 = hostTop + arret - avance;   // la pointe arrive
            var s2 = hostTop + obs.by;           // le mot sort par le haut
            var f = arret / Hf;
            var p1 = (s1 - sA) / (sB - sA);
            var p2 = (s2 - sA) / (sB - sA);
            if (f > 0.02 && p1 > 0.02 && p2 > p1 && p2 < 0.97) {
              svg.style.animationTimingFunction =
                'linear(0, ' + f.toFixed(3) + ' ' + (p1 * 100).toFixed(1) + '% ' +
                (p2 * 100).toFixed(1) + '%, 1)';
            }
          }
        }
      }
      // La classe ne se pose qu'avec la couche : le hero, mesuré puis
      // écarté, la portait pour rien.
      host.classList.add('vhud-host');
      aPoser.push(host, layer);
    }

    // H : hauteur du contenu, seule zone où un mot a le droit de se poser.
    // Hf : celle de la couche, pont compris — elle règle les pourcentages.
    // Les confondre décalait chaque mot du bas de la longueur du pont.
    // LES BLOCS DE CODE. Aucune branche ne les relie au fil : rien ne se
    // decroche quand ils derivent, la ou les mots restent cloues. Ils passent
    // AVANT les mots et rejoignent les rectangles interdits.
    //
    // DANS LES GOUTTIERES, et nulle part ailleurs : c'est la qu'un appareil de
    // mesure ecrit ses releves, et la que rien ne se lit.
    function blocs(bad, motif, W, H, Hf, y0, hostTop, idx) {
      var bx = [0.018, 0.075, 0.868, 0.925];
      var by = [0.1, 0.24, 0.38, 0.52, 0.66, 0.8];
      var mis = [], j, cc;
      var max = W < 700 ? 1 : W < 1100 ? 2 : 3;
      for (j = 0; j < bx.length * by.length && mis.length < max; j++) {
        var g = { x: W * bx[j % bx.length], y: H * by[Math.floor(j / bx.length)] };
        if (g.y < y0 + 20) continue;
        // 82 px : un vidage de deux octets plus la garde. A trois octets il ne
        // tenait plus dans la gouttiere d'un 1280. Et 30 px de rab en hauteur :
        // le bloc DERIVE de 26 px, il doit etre libre partout ou il peut aller.
        var box = { l: g.x - 10, r: g.x + 82, t: g.y - 42, b: g.y + 88 };
        if (box.b > H - 8 || box.r > W - 8 || box.l < 4) continue;
        var libre = true;
        for (var q = 0; q < bad.length; q++) {
          var z = bad[q];
          if (box.l < z.r && box.r > z.l && box.t < z.b && box.b > z.t) { libre = false; break; }
        }
        for (cc = 0; libre && cc < mis.length; cc++) {
          if (Math.abs(mis[cc].y - g.y) < 90 && Math.abs(mis[cc].x - g.x) < 200) libre = false;
        }
        if (!libre) continue;
        mis.push(g);
        bad.push({ l: box.l, r: box.r, t: box.t, b: box.b, lx: box.l, rx: box.r, ty: box.t, by: box.b });

        var el = DOC.createElement('pre');
        el.className = 'vhud__code';
        el.style.left = (g.x / W * 100).toFixed(2) + '%';
        el.style.top = (g.y / Hf * 100).toFixed(2) + '%';
        el.textContent = vidage(idx * 31 + j * 7 + 3, Math.round(hostTop + g.y));
        motif.appendChild(el);
      }
    }

    function mots(bad, layer, motif, svg, x, y0, W, H, Hf, hostTop, idx, pool) {
      if (pool.length < 3) return;

      // Cases candidates : les marges MAIS AUSSI les couloirs intérieurs.
      // Grille resserrée — avec cinq rangées, les sections chargées (avis,
      // multicolonnes) ne trouvaient aucune case libre et restaient muettes.
      var cx = [0.03, 0.105, 0.185, 0.325, 0.485, 0.655, 0.79, 0.875, 0.945];
      var cy = [0.09, 0.2, 0.31, 0.42, 0.53, 0.64, 0.75, 0.86];
      var free = [];
      for (var a = 0; a < cx.length; a++) {
        for (var c = 0; c < cy.length; c++) {
          var px = W * cx[a], py = H * cy[c];
          if (py < y0 + 30) continue;                       // au-dessus du fil : pas de branche possible
          var box = { l: px - 8, r: px + (W < 700 ? 118 : 132), t: py - 12, b: py + 14 };
          if (box.r > W - 10 || box.l < 6) continue;
          var ok = true;
          for (var k = 0; k < bad.length; k++) {
            var z = bad[k];
            if (box.l < z.r && box.r > z.l && box.t < z.b && box.b > z.t) { ok = false; break; }
          }
          if (ok) free.push({ x: px, y: py });
        }
      }
      if (free.length < 2) return;

      // jamais plus de nœuds que de mots distincts, et on étale les choix
      var want = Math.min(free.length, pool.length, W < 700 ? 3 : W < 900 ? 5 : 8);
      var step = Math.max(1, Math.floor(free.length / want));
      var picks = [];
      for (var p = 0; p < free.length && picks.length < want; p += step) picks.push(free[p]);


      for (var n = 0; n < picks.length; n++) {
        var pt = picks[n];
        // La branche part DU FIL, à angle droit : une équerre, jamais une
        // diagonale. Elle s'arrête juste avant le mot.
        var bx = pt.x < x ? pt.x + 6 : pt.x - 6;
        var coude = Math.round(pt.y - 26);
        if (coude > y0 + 8 && x > 2 && x < W - 2) {
          // La branche court derrière elle aussi.
          var d = tronconne(false, coude, Math.min(x, bx), Math.max(x, bx), bad);
          if (d) {
            d += 'M' + Math.round(bx) + ' ' + coude + ' V' + Math.round(pt.y);
            var br = DOC.createElementNS(NS, 'path');
            br.setAttribute('class', 'vhud__line');
            br.setAttribute('d', d);
            svg.appendChild(br);
          }
        }

        var node = DOC.createElement('div');
        node.className = 'vhud__n';
        node.style.left = (pt.x / W * 100).toFixed(2) + '%';
        node.style.top = (pt.y / Hf * 100).toFixed(2) + '%';
        node.style.setProperty('--i', n);
        if (fil) node.style.setProperty('--p', pct(hostTop + pt.y));
        node.innerHTML = '<i class="vhud__m"></i><span class="vhud__w"></span><em class="vhud__c"></em>';
        // décalage premier avec la taille du vivier : deux nœuds d'une même
        // section ne peuvent pas tomber sur le même mot
        node.querySelector('.vhud__w').textContent = pool[(idx * 2 + n * 3) % pool.length];
        node.querySelector('.vhud__c').textContent =
          TAG[(idx + n) % TAG.length] + ':' +
          Math.round(pt.y).toString(16).toUpperCase().padStart(3, '0') +
          '.' + String(idx + 1).padStart(2, '0');
        layer.appendChild(node);
      }
    }
  }

  // Une seule file : les déclencheurs se chevauchent, ils doivent se fondre
  // en un relevé, pas s'empiler.
  var t = null;
  function replanifie(ms) { clearTimeout(t); t = setTimeout(build, ms); }

  if (DOC.readyState === 'loading') DOC.addEventListener('DOMContentLoaded', function () { replanifie(60); });
  else replanifie(60);
  // Un dernier relevé une fois les apps posées. Le sceau le rend gratuit si
  // rien n'a bougé entre-temps.
  window.addEventListener('load', function () {
    replanifie(60);
    setTimeout(function () { replanifie(0); }, 1400);
  });

  // Les polices arrivent après le premier relevé : un titre mesuré en police
  // de repli est bien plus étroit qu'en Archivo Black, et le fil se trouvait
  // dessiné là où le mot avait fini par s'étendre. On refait le relevé quand
  // la substitution est faite — c'est le signal exact, pas un délai deviné.
  if (DOC.fonts && DOC.fonts.ready && DOC.fonts.ready.then) {
    DOC.fonts.ready.then(function () {
      // On EFFACE le sceau avant de replanifier. La substitution de police
      // elargit les mots sans toucher a la hauteur du document : le sceau
      // concluait « rien n'a bouge » et le releve etait saute. Le fil gardait
      // donc les decoupes mesurees en police de repli — et traversait le mot
      // « PORTES », plus large une fois Archivo Black posee.
      sceau = '';
      replanifie(80);
    });
  }
  window.addEventListener('resize', function () { replanifie(250); }, { passive: true });

  // La page grandit encore après `load` (images, widgets) : mesuré trop tôt,
  // le fil s'arrêtait avant le bas. Le premier appel ne fait que constater la
  // hauteur de départ, il ne relance rien.
  if ('ResizeObserver' in window) {
    var derniere = -1;
    new ResizeObserver(function () {
      var h = DOC.documentElement.scrollHeight;
      if (derniere < 0) { derniere = h; return; }
      if (Math.abs(h - derniere) < 60) return;
      derniere = h;
      replanifie(180);
    }).observe(DOC.body);
  }
})();
